// LICENSE_CODE ZON
'use strict'; /*jslint react:true*/
import React, {
    useEffect,
    useCallback,
    useContext,
} from 'react';
import passwd_util from '/www/lum/pub/util/passwd.js';
import {FIELD_KIND} from '@pub/shared/constants.js';
import {Input as Input_comp} from '@pub/comp/input';
import {get_password_error, get_url_error, get_email_error,
    get_len_error} from './utils.js';
import {REQUIRED_ERROR, PASSWORD_KIND} from './constants.js';
import {Form_disabled_ctx} from './contexts.js';
import {use_controls, use_validity, use_value} from './hooks.js';
import {Item} from './item.js';
import './form.less';

const validate_input = meta=>{
    const {value, required, kind, valid_with, max_len} = meta;
    let error = null;
    if (required)
        error = value ? null : REQUIRED_ERROR;
    if (!error&&kind==FIELD_KIND.URL)
        error = get_url_error(value, valid_with);
    if (!error&&kind==FIELD_KIND.EMAIL)
        error = get_email_error(value, valid_with);
    if (!error&&max_len)
        error = get_len_error(value, max_len);
    if (!error&&kind==FIELD_KIND.PASSWORD)
    {
        const validate_passwd = meta.password_kind==PASSWORD_KIND.SIGNIN
            ? passwd_util.valid_login
            : passwd_util.valid_signup;
        error = get_password_error(value, validate_passwd);
    }
    if (!error&&meta.custom_validator)
        error = meta.custom_validator(value);
    return error;
};

export function Input({
    title,
    hint: _hint,
    field,
    required,
    disabled: dis,
    kind=FIELD_KIND.TEXT,
    password_kind=PASSWORD_KIND.SIGNUP,
    max_len,
    rows=4,
    valid_with,
    custom_validator,
    ...input_props
})
{
    const disabled_inner = useContext(Form_disabled_ctx);
    const validity = use_validity(field);
    const {change_value, change_validity, remove_fields,
        push_meta} = use_controls();
    const handle_change = useCallback(value=>
        change_value(field, value), [field, change_value]);
    useEffect(()=>{
        push_meta(field, {
            required,
            max_len,
            kind,
        });
    }, [field, required, kind, max_len]);
    useEffect(()=>()=>remove_fields([field]), [field]);
    useEffect(()=>{
        const is_hidden = kind==FIELD_KIND.HIDDEN;
        if (!is_hidden)
            return;
        const val = input_props.value;
        if (is_hidden && val===undefined)
            throw new Error(`invalid hidden field (${field}) value: ${val}`);
        change_value(field, val);
    }, [kind, field, input_props.value, change_value]);
    const disabled = dis || disabled_inner;
    const val = use_value(field);
    useEffect(()=>{
        const error = validate_input({
            value: val,
            required,
            kind,
            max_len,
            valid_with,
            password_kind,
            custom_validator,
        });
        change_validity(field, error);
    }, [val, required, kind, max_len, valid_with, change_validity,
        password_kind, custom_validator]);
    const error = validity ?? '';
    let hint = _hint;
    if (valid_with)
    {
        const note = `Note: write "${valid_with}" in order to skip it`;
        hint = hint ? <>{hint}<br/>{note}</> : note;
    }
    let type;
    if (kind==FIELD_KIND.PASSWORD)
        type = 'password';
    else if (kind==FIELD_KIND.EMAIL)
        type = 'email';
    else if (kind==FIELD_KIND.HIDDEN)
        type = 'hidden';
    return <Item title={title} hint={hint} required={required} is_div
      is_hidden={type=='hidden'}>
      <Input_comp value={val} on_change={handle_change}
        error={error} rows={rows} type={type} {...input_props}
        disabled={disabled}/>
    </Item>;
}
